import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const ButtonWithTooltip = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .more-info {
    color: #dedede;
    margin-left: 12px;
  }
`;
